import {
  BirthDayApiProps,
  UpcomingBirthdayResponse,
} from '../../../types/Dashboard/Birthdays/birthdayTypes'
import { employeeProfileData } from '../../../types/Dashboard/employeeSearchTypes'
import {
  JobOpeningsApiProps,
  JobVacanciesResponse,
} from '../../../types/Dashboard/JobOpenings/JobOpeningsTypes'
import {
  scheduleInterviewApiProps,
  ScheduleInterviewResponse,
} from '../../../types/Dashboard/ScheduledInterviews/ScheduleInterviewsType'
import {
  ServiceAnniversariesApiProps,
  UpcomingServiceAnniversariesResponse,
} from '../../../types/Dashboard/ServiceAnniversaries/serviceAnniversaries'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../utils/apiUtils'
import { AllowedHttpMethods, dashboardApiConfig } from '../apiList'

const getAllJobVacancies = async (
  props: JobOpeningsApiProps,
): Promise<JobVacanciesResponse> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: dashboardApiConfig.getAllJobVacancies,
    method: AllowedHttpMethods.get,
    params: {
      endIndex: props.endIndex ?? 20,
      startIndex: props.startIndex ?? 0,
      searchJobTitle: props.searchJobTitle ?? '',
      status: props.status ?? 'Open',
      vendorEmployeeId: props.vendorEmployeeId ?? '',
      isVendor: props.isVendor ?? false,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}
const getAllPendingInterviewComments = async (
  props: scheduleInterviewApiProps,
): Promise<ScheduleInterviewResponse> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: dashboardApiConfig.getAllPendingInterviewComments,
    method: AllowedHttpMethods.get,
    params: {
      endIndex: props.endIndex ?? 20,
      startIndex: props.startIndex ?? 0,
      employeeId: props.employeeId,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getUpcomingBirthdayAnniversaries = async (
  props: BirthDayApiProps,
): Promise<UpcomingBirthdayResponse> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: dashboardApiConfig.getUpcomingBirthdayAnniversaries,
    method: AllowedHttpMethods.get,
    params: {
      endIndex: props.endIndex ?? 3,
      startIndex: props.startIndex ?? 0,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}
const getUpcomingServiceAnniversaries = async (
  props: ServiceAnniversariesApiProps,
): Promise<UpcomingServiceAnniversariesResponse> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: dashboardApiConfig.getUpcomingServiceAnniversaries,
    method: AllowedHttpMethods.get,
    params: {
      endIndex: props.endIndex ?? 3,
      startIndex: props.startIndex ?? 0,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getFinancialYear = async (country: string): Promise<string> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: dashboardApiConfig.getFinancialYear,
    method: AllowedHttpMethods.get,
    params: {
      country,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const imageFix = async (): Promise<string | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: dashboardApiConfig.imageFix,
    method: AllowedHttpMethods.get,
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const searchEmployee = async (
  searchValue: string,
): Promise<employeeProfileData[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: dashboardApiConfig.searchEmployee,
    method: AllowedHttpMethods.get,
    params: {
      searchStr: searchValue,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const dashboardApi = {
  getAllJobVacancies,
  getAllPendingInterviewComments,
  getUpcomingBirthdayAnniversaries,
  getUpcomingServiceAnniversaries,
  getFinancialYear,
  searchEmployee,
  imageFix,
}

export default dashboardApi
